import type { Tilgang } from '../skall/tilgang.ts';

/** Rommet Hypoteser sitt navn i kontrakten (`Room`). */
export const HYPOTESER = 'hypoteser' as const;

/**
 * Rommets sider (DD-01 presisert 2026-09-26, `admin-hypoteser.jsx` SIDER): hvem som ser hvilke
 * følger rollen i rommet, og forsiden står først. Registeret er for alle i rommet; rommets
 * Innstillinger bare for eier (H2.3 andre runde, tabellen HVEM SER HVA).
 *
 * Ikonene er `admin-hypoteser.jsx` sitt ikonkart. `admin-skall.jsx` tegner «Til deg» med
 * `enter-outline` og «Mine hypoteser» med `person-outline` — de to wireframene spriker, og
 * rommets egen spesifikasjon er fulgt (rapportert som avvik).
 */
export interface HSide {
  navn: string;
  /** Fanens ord under 900 px — «Mine» for «Mine hypoteser». */
  kort: string;
  sti: string;
  tast: string;
  ikon: string;
}

export const H_INNBOKS: HSide = { navn: 'Innboks', kort: 'Innboks', sti: '/h/innboks', tast: 'i', ikon: 'file-tray-outline' };
export const H_TIL_DEG: HSide = { navn: 'Til deg', kort: 'Til deg', sti: '/h/til-deg', tast: 't', ikon: 'arrow-forward-circle-outline' };
export const H_MINE: HSide = { navn: 'Mine hypoteser', kort: 'Mine', sti: '/h/mine', tast: 'm', ikon: 'document-text-outline' };
export const H_REGISTERET: HSide = { navn: 'Registeret', kort: 'Registeret', sti: '/h/registeret', tast: 'r', ikon: 'list-outline' };
/**
 * «Møter» (H3.2, W1): beslutningsmøtene, for leser og opp. En bidragsyter har ikke siden — er hun
 * beslutningstaker, står møtet hennes i «Til deg». Tasten er ø, fordi o er Organisasjon for eier.
 */
export const H_MOETER: HSide = { navn: 'Møter', kort: 'Møter', sti: '/h/moter', tast: 'ø', ikon: 'calendar-outline' };
export const H_INNSTILLINGER: HSide = { navn: 'Innstillinger', kort: 'Innstillinger', sti: '/h/innstillinger', tast: 'n', ikon: 'settings-outline' };

/** Alle rommets sider, for sidetittelen. Hvem som ser dem, avgjør `hSiderFor`. */
export const H_ALLE: HSide[] = [H_INNBOKS, H_TIL_DEG, H_MINE, H_REGISTERET, H_MOETER, H_INNSTILLINGER];

/**
 * Innboksen er for behandlere i rommet og for eier (tabellen i DD-01). `kanSkrive` er
 * behandler — eier har behandler i hvert rom i `access` (M4.8).
 */
export const erHBehandler = (tilgang: Tilgang): boolean => tilgang.eier || tilgang.kanSkrive(HYPOTESER);

/** Leser og opp ser notatene (Kh7); en bidragsyter ser aldri ikonet. */
export const erHLeserPluss = (tilgang: Tilgang): boolean => {
  if (tilgang.eier) return true;
  return tilgang.kanSe(HYPOTESER) && tilgang.rolleI(HYPOTESER) !== 'bidragsyter';
};

/** Sidene personen har, forsiden først og resten i fast rekkefølge (P3). */
export function hSiderFor(tilgang: Tilgang): HSide[] {
  // Ukjent er strengest: før «meg» har svart, vet ingen hvilke sider personen har.
  if (!tilgang.kjent) return [];
  const forside = erHBehandler(tilgang) ? H_INNBOKS : H_MINE;
  const synlige = H_ALLE.filter((s) => (s === H_INNBOKS ? erHBehandler(tilgang) : s === H_INNSTILLINGER ? tilgang.eier : s === H_MOETER ? erHLeserPluss(tilgang) : true));
  return [forside, ...synlige.filter((s) => s !== forside)];
}
